module.exports = "https://static.wagwalking.com/_next/static/images/dog-avatar-2546fae7c3da8382f62c9e3e8aa16fac.svg";